import { useAtom } from 'jotai'
import { ProductCreditAPI } from '../services/product-credit.api'
import { productCreditState } from '../stores/product-credit.store'

export function useProductCredit({ baId, ushopCountryCode, token }: { baId: string; ushopCountryCode: string; token: string }) {
    const [productCredits, setProductCredits] = useAtom(productCreditState)

    const fetchProductCredits = async () => {
        try {
            const res = await ProductCreditAPI.productCredit({ baId, ushopCountryCode, token })
            setProductCredits(res.data)
        } catch (error) {
            console.error(error)
        }
    }

    return {
        productCredits,
        fetchProductCredits
    }
}
